import React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";

const products = [
  {
    img: "https://i.ibb.co/GHb596N/product-2.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/Jq3HL67/product-3.png",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/XjHLLg1/product-4.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/59yRmZz/product-5.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/KqNSnqs/product-6.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/TrGd3ZR/product-7.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/SV5Mm9Q/product-8.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/C0FtNTj/product-9.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/DbjtjTL/product-10.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/njLgTfZ/product-11.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/4RXcvC9/product-12.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/0VQLq1L/product-13.png",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/R769PX6/product-14.jpg",
    name: "Elastic Product",
  },
  {
    img: "https://i.ibb.co/bX4xF2z/product-1.jpg",
    name: "Elastic Product",
  },
];

const Products = () => {
  return (
    <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
        <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
          Portfolio
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
          Our Products
        </h2>
      </div>

      <div className="pb-16 grid gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 items-stretch">
        <PhotoProvider>
          {products.map((p, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl border border-slate-200/80 shadow-sm hover:shadow-xl hover:border-slate-300 transition-all duration-300 overflow-hidden flex flex-col justify-between"
              data-aos="fade-up"
              data-aos-delay={(i % 4) * 50}
            >
              <div className="relative overflow-hidden bg-slate-100 aspect-square flex items-center justify-center">
                <PhotoView src={p.img}>
                  <img
                    src={p.img}
                    alt={p.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 cursor-pointer"
                  />
                </PhotoView>
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-[10px] font-bold uppercase tracking-wider text-slate-700 px-2 py-0.5 rounded-md pointer-events-none shadow-sm">
                  Zoom
                </div>
              </div>
              <div className="p-4 bg-white border-t border-slate-100 flex items-center justify-between">
                <p className="font-bold text-slate-800 text-sm">{p.name}</p>
                <span className="text-xs text-[#EB4438] font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  Inspect &rarr;
                </span>
              </div>
            </div>
          ))}
        </PhotoProvider>
      </div>
    </section>
  );
};

export default Products;
